import PropTypes from 'prop-types';

import './ListingItem.scss';

const ListingItem = ({ className = '', children }) => (
  <section className={`listing-section ${className}`}>{children}</section>
);

ListingItem.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
    .isRequired,
  className: PropTypes.string
};

export default ListingItem;
